<div class="aupris_main my-full-screen-dialog">
  <div class="text-center" style="font-size:20px;font-weight: bold;margin-bottom: 10px;">{{languageData?.Bestelloptionen?.Var_vat_notice ||'Steuerhinweis'}} </div>
<div class="inline-block">
  <span class="dblock">{{infotext}}</span>
</div>
<div class="text-right">
  <button class="au-btn btn-default" [ngStyle]="{background: 'var(--primaryColour)',color: 'var(--primaryTextColour)'}" (click)="onclick()"
    style="margin-top:5px">{{languageData['Popups'].Var_Schlieben || 'Schließen'}}</button>
  </div>
</div>